export default {
    namespaced: true,
    state () {
        return {
            id: 0,
            title: '',
            subtitle: '',
            slug: '',
            sku: '',
            categories: [],
            brands: [],
            tags: [],
            content: '',
            short_description: '',
            meta_description: '',
            meta_keywords: '',
            status: '',
            stocks: [],
            gallery: [],
            attribute_entities: [],
            attribute_entity_notes: {},
            attribute_entity_options: {},
            attribute_values: [],
            variables: [],
            variations: [],
            product_family: null,
            errors: {},
            lock: null,
            type: '',
            selected_variable_id: null,
            is_wishlisted: false,
            is_waiting_listed: false,
            initialized: false
        }
    },
    getters: {
        isLoaded(state) {
            return !!state.id;
        },
        selectedVariable(state) {
            return state.variables.filter(variable => {
                return variable.id === state.selected_variable_id;
            })[0];
        }
    },
    mutations: {
        init (state, data) {
            for (const [key, value] of Object.entries(data)) {
                state[key] = value;
            }
            state.initialized = true;
        },
        reset (state) {
            state.id = 0;
            state.title = '';
            state.subtitle = '';
            state.slug = '';
            state.sku = '';
            state.categories = [];
            state.brands = [];
            state.tags = [];
            state.content = '';
            state.short_description = '';
            state.meta_description = '';
            state.meta_keywords = '';
            state.status = '';
            state.stocks = [];
            state.gallery = [];
            state.attribute_entities = [];
            state.attribute_entity_notes = {};
            state.attribute_entity_options = {};
            state.attribute_values = [];
            state.variables = [];
            state.variations = [];
            state.product_family = null;
            state.errors = {};
            state.lock = null;
            state.type = '';
            state.selected_variable_id = null;
            state.is_wishlisted = false;
            state.is_waiting_listed = false;
            state.initialized = false;
        },
        setSelectedVariableId (state, data) {
            state.selected_variable_id = Number(data);
        }
    }
}
